$(document).on('turbolinks:load', function () {
    $('#phonenumber').hide()
    $('#emailaddress').show()

        $(".submitform").click(function () {
                return true;    
        });

    $(".contactmethodcheck").change(function () {
        checked = $(".contactmethodcheck:checked").length;
        if (checked > 0) {
            if ($('#contactemail').is(':checked')) {
                $('#emailaddress').attr('required', 'required');

                $('#emailaddress').show()

            } else {
                $('#emailaddress').removeAttr('required');

                $('#emailaddress').hide()

            }

            if ($('#contactphone').is(':checked')) {
                $('#phonenumber').attr('required', 'required');

                $('#phonenumber').show()

            } else {
                $('#phonenumber').removeAttr('required');

                $('#phonenumber').hide()

            }
        } else {
            $(this).prop("checked", true);

        }
    });



})
